import { h } from 'vue';

export default {
    // functional: true,

    render()
    {
        return h(
            'h3',

            {
                // staticClass: data.staticClass,

                class: 'vh-offcanvas-title',
            },

            this.$slots
        );
    },
};
